// plugins/hydrated.client.js
export default () => {
  if (typeof window === 'undefined') return;

  // wait until hydration settles, then enable animations
  window.addEventListener('load', () => {
    requestAnimationFrame(() => {
      // document.documentElement.classList.add('app-hydrated');
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper) wrapper.classList.add('app-hydrated');
    });
  });
};
